import { render, staticRenderFns } from "./MenuManage.vue?vue&type=template&id=1da98f85&scoped=true&"
import script from "./MenuManage.vue?vue&type=script&lang=js&"
export * from "./MenuManage.vue?vue&type=script&lang=js&"
import style0 from "./MenuManage.vue?vue&type=style&index=0&id=1da98f85&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da98f85",
  null
  
)

export default component.exports